import { render } from "./CartViewSummary.vue?vue&type=template&id=32a7712a"
import script from "./CartViewSummary.vue?vue&type=script&lang=js"
export * from "./CartViewSummary.vue?vue&type=script&lang=js"

import "./CartViewSummary.vue?vue&type=style&index=0&id=32a7712a&lang=scss"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__